import {register} from "swiper/element/bundle";
import {AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SwiperComponent implements AfterViewInit {
  @ViewChild('swiperContainer', {static: true})
  swiperContainer!: ElementRef;

  @Input()
  swiperId = '';
  @Input()
  paginationType = 'fraction'
  @Input()
  navigation = false;
  @Input()
  hideNavigationOnMobile = false;

  ngAfterViewInit(): void {
    register();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const params = {
      injectStyles: [
        '.swiper-pagination-bullet {width: 8px !important;height: 8px !important;background: #eaeaea !important; opacity: 1 !important;}',
        '.swiper-pagination-bullet-active {width: 8px !important;height: 8px !important;background: #0b57d0 !important;opacity: 1 !important;}',
        '.swiper-button-next, .swiper-button-prev {color: #9aa3b2 !important;opacity: .78;transition: color .2s ease, opacity .2s ease;}',
        '.swiper-button-next:hover, .swiper-button-prev:hover {color: #6f7785 !important;opacity: 1;}',
        '.swiper-pagination.swiper-pagination-hidden {opacity: .1}',
        ...(this.hideNavigationOnMobile ? [
          '@media (max-width: 599px) {.swiper-button-next, .swiper-button-prev {display: none !important;}}'
        ] : [])
      ],
      autoplay: prefersReducedMotion ? false : {
        delay: 30000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      },
      threshold: 30,
      grabCursor: true,
      navigation: this.navigation,
      pagination: {
        type: this.paginationType,
        clickable: true,
        hideOnClick: false,
      }
    };

    const container = this.swiperContainer.nativeElement;
    Object.assign(container, params);
    container.initialize();
  }
}
